import { useContext } from 'react';
import styled from 'styled-components';
import { SubmitButtonContext } from '../contexts/SubmitButtonContext';
import { jsx as _jsx } from "react/jsx-runtime";
const TrayWrapper = styled.div.withConfig({
  displayName: "RenderSubmitButton__TrayWrapper",
  componentId: "g8pmtu-0"
})([""]);
const RenderSubmitButton = () => {
  const {
    submitButton
  } = useContext(SubmitButtonContext);
  return /*#__PURE__*/_jsx(TrayWrapper, {
    children: submitButton && submitButton({})
  });
};
export default RenderSubmitButton;